import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";

import { services } from "../../../../../../app/services";
import { WirelessTicket } from "../../../../../../components/models/wireless-ticket";
import { ServiceDocumentationItem } from "../../../../../../components/subscription-detail/shortcut-menu/items/service-documentation/service-documentation";
import { WirelessSuppliersItem } from "../../../../../../components/subscription-detail/shortcut-menu/items/wireless-suppliers/wireless-suppliers-item";
import { WirelessTicketsItem } from "../../../../../../components/subscription-detail/shortcut-menu/items/wireless-tickets/wireless-tickets-item";
import { ShortcutMenu } from "../../../../../../components/subscription-detail/shortcut-menu/shortcut-menu";
import { ProductType } from "../../../../../../helpers/enums/productType";
import { WirelessSubscriptionDetails } from "../../../../types";

@Component({
  selector: "wireless-shortcut-menu",
  templateUrl: "wireless-shortcut-menu.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ServiceDocumentationItem, ShortcutMenu, WirelessTicketsItem, WirelessSuppliersItem],
})
export class WirelessShortcutMenuComponent {
  protected subscription = input.required<WirelessSubscriptionDetails>();
  protected tickets = input.required<WirelessTicket[]>();
  protected suppliers = computed(() => [this.subscription().supplier]);

  protected readonly serviceDocumentationUrl = services[ProductType.Wireless].docs;
}
